import {environment} from '~env/environment';

export const COUNTER_UPPER_LIMIT = 100;

export const FF_CART_UPDATE = 'FF_CART_UPDATE';

export const PI_CART_FAILURE_LOGGER_API = () => `${environment.svcProductIndex()}/api/public/add-to-cart-failure`;
